import React, { useEffect, useState } from 'react'
import Layout from './Layout'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../../components/Message'
import Loader from '../../components/Loader'
import { deleteProductReviewsDetails, listProductDetails, listProductReviewsDetails } from '../../actions/productActions'

const ReviewSceen = ({ match, history }) => {
    const userLogin = useSelector((state) => state.userLogin)
    const { userInfo } = userLogin

    const productId = match.params.id;
    const dispatch = useDispatch()

    const [eventType, setEventType] = useState("")
    const [idReview, setIdReview] = useState("")
    const [showDiag, setShowDiag] = useState(false)
    const [loadEvent, setLoadEvent] = useState(false)


    // const productDetails = useSelector((state) => state.productDetails)
    // const { loading, error, product } = productDetails


    const reviewsProd = useSelector((state) => state.productReviews)
    const { loading, error, reviews } = reviewsProd


    useEffect(() => {
        if (userInfo && userInfo.isAdmin) {
            // dispatch(listProductDetails(productId))
            dispatch(listProductReviewsDetails(productId))
        } else {
            history.push('/login');
        }
    }, [history, userInfo, productId, dispatch])

    const showDiagHundle = (idR, even) => {
        setIdReview(idR);
        setEventType(even);
        setShowDiag(true)
        setLoadEvent(false)
    }
    const hideDiagHundle = () => {
        setIdReview("");
        setEventType("");
        setShowDiag(false)
        setLoadEvent(false)
    }

    const confirmHundle = async () => {
        if (eventType === "delete") {
            setLoadEvent(true)
            await dispatch(deleteProductReviewsDetails(idReview)).then(() => { });
            await dispatch(listProductReviewsDetails(productId)).then(() => { });
            hideDiagHundle();
        } else {
            hideDiagHundle();
        }
    }


    return (
        <Layout>
            <div className='w-full pb-20'>
                <div className='flex justify-between'>
                    <h1 className='text-xl font-600 pb-4'>Reviews Product</h1>
                </div>
                {/*  */}

                <div class="flex flex-col bg-white rounded-md mt-4 ">
                    <div class=" sm:-mx-6 lg:-mx-8 ">
                        <div class="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                            <div class="overflow-hiddens">
                                <table class="min-w-full ">
                                    <thead class="bg-white border-b">
                                        <tr>

                                            <th
                                                scope="col"
                                                class="text-sm font-medium text-gray-900 px-6 py-4 text-left"
                                            >
                                                Date
                                            </th>
                                            <th
                                                scope="col"
                                                class="text-sm font-medium text-gray-900 px-6 py-4 text-left"
                                            >
                                                Client
                                            </th>
                                            <th
                                                scope="col"
                                                class="text-sm font-medium text-gray-900 px-6 py-4 text-left"
                                            >
                                                Comment
                                            </th>

                                            <th
                                                scope="col"
                                                class="text-sm font-medium text-gray-900 px-6 py-4 text-left"
                                            >
                                                Rating
                                            </th>
                                            <th
                                                scope="col"
                                                class="text-sm font-medium text-gray-900 px-6 py-4 text-left"
                                            >

                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <Loader />
                                        ) : error ? (
                                            <Message variant="danger">{error}</Message>
                                        ) : (
                                            <>
                                                {reviews?.map((review, id) => (
                                                    <tr class="bg-white border-b transition duration-300 ease-in-out hover:bg-gray-100">

                                                        <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
                                                            {review.createdAt?.substring(0, 10)}
                                                        </td>
                                                        <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
                                                            {review.name}
                                                        </td>
                                                        <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
                                                            {
                                                                review.comment
                                                            }
                                                        </td>
                                                        <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">

                                                            <div className="flex items-center">
                                                                <div>
                                                                    <span
                                                                        className={`text-sm cursor-pointer text-gray-300`}>
                                                                        ({parseFloat(review.rating).toFixed(1)})
                                                                    </span>
                                                                    {[1, 2, 3, 4, 5].map((star) => (
                                                                        <span
                                                                            key={star}
                                                                            className={`text-sm cursor-pointer ${star <= review.rating ? 'text-yellow-400' : 'text-gray-300'
                                                                                }`}
                                                                        >
                                                                            ★
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className='text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap'>
                                                            <button onClick={() => showDiagHundle(review.id, "delete")}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-yellow-400">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                                                </svg>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>
                                        )}
                                        <tr className="h-16"></tr>
                                    </tbody>
                                </table>
                                {/* <Paginate section={"orderlist"} pages={pages} page={page} /> */}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {showDiag ? (
                <>
                    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center">
                        <div className="bg-white p-6 rounded shadow-md">
                            <h3 className="text-lg font-bold mb-4">Confirmation</h3>
                            <p className="mb-4">Voulez-vous confirmer votre choix ?</p>
                            <div className="flex justify-end">
                                <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2" onClick={() => confirmHundle()} disabled={loadEvent}> {loadEvent ? <div role="status">
                                    <svg aria-hidden="true" className="w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-danger" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                    </svg>
                                    <span className="sr-only">Loading...</span>
                                </div> : "Confirm"}  </button>
                                <button className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded" onClick={() => hideDiagHundle()} disabled={loadEvent}> Annuler </button>
                            </div>
                        </div>
                    </div>
                </>
            ) : null}

        </Layout>
    )
}

export default ReviewSceen